module.exports = __webpack_public_path__ + "static/img/product1-4.234103d5.png";